import { msgid, ngettext } from "ttag";

import { Meters, isoKilometers, isoMiles } from "../../models/nominals";
import { DistanceUnit, getDistanceUnit } from "../../utils/distance";
import { metersToKilometers, metersToMiles } from "../../utils/maps";

export const formatDistance = (
    distance: Meters,
    decimalPoint?: number,
): string => {
    const unit = getDistanceUnit();
    if (unit === DistanceUnit.KILOMETERS) {
        const km = metersToKilometers(distance);
        return isoKilometers.unwrap(km).toFixed(decimalPoint);
    }
    const miles = metersToMiles(distance);
    return isoMiles.unwrap(miles).toFixed(decimalPoint);
};

export const formatDistanceWithSuffix = (
    distance: Meters,
    decimalPoint?: number,
): string => {
    const formattedDistance = formatDistance(distance, decimalPoint);
    const numericDistance = parseFloat(formattedDistance);
    const unit = getDistanceUnit();
    if (unit === DistanceUnit.KILOMETERS) {
        return ngettext(
            msgid`${formattedDistance} km`,
            `${formattedDistance} km`,
            numericDistance,
        );
    }
    return ngettext(
        msgid`${formattedDistance} mile`,
        `${formattedDistance} miles`,
        numericDistance,
    );
};
